module.exports = __webpack_public_path__ + "img/2010-2.3c73ddf5.jpg";